import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { upsells } from '../data/upsells';
export function NextSteps() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-88" data-mp="30nysan1e16h">
      <div className="mx-auto max-w-5xl" data-id="element-89" data-mp="3u7qqr4ap8bhr">
        <SectionHeading overline="Próximos pasos" size="lg" title={<>
              Cuando domines esta técnica,{' '}
              <span className="italic text-terracotta-500" data-id="element-91" data-mp="qrtnzgeva5tg">podés ir por más</span>
            </>} subtitle="Si te enamorás de las flores prensadas, estos son los dos caminos para llevar tus creaciones a piezas todavía más especiales y vendibles." data-id="element-90" data-mp="3u8sadx5s66b3" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-92" data-mp="h0pakl4uat0q">
          {upsells.map(upsell => <article key={upsell.name} className="flex h-full flex-col overflow-hidden rounded-4xl border border-gold-200/60 bg-cream" data-id="element-93" data-mp="c3p4ia7zpq9m">
              <div className="bg-bone px-6 py-9" data-id="element-94" data-mp="19jm6ggwb88mx">
                <img src={upsell.image} alt={`Portada de ${upsell.name}`} className="mx-auto w-full max-w-[230px] drop-shadow-[0_22px_36px_rgba(56,52,44,0.2)]" data-id="element-95" data-mp="14r2u1n9czjjp" />
              </div>
              <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-96" data-mp="3d9ex0h7msfy">
                <h3 className="font-serif text-[1.75rem] leading-tight text-sage-800" data-id="element-97" data-mp="3chn80qqheuy">
                  {upsell.name}
                </h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-98" data-mp="3qq3c8ns72egp">
                  {upsell.body}
                </p>
                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-99" data-mp="3bsb1e8xlee8u">
                  {upsell.highlights.map(highlight => <li key={highlight} className="rounded-full bg-sage-100 px-3 py-1 text-[11.5px] font-medium text-sage-700" data-id="element-100" data-mp="3gsyq2nycmizw">
                      {highlight}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}